/*
 * @Author: ken yang
 * @Date: 2023-05-31 17:36:33
 * @LastEditTime: 2023-05-31 17:38:34
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/utils/globalFunc/borwserLang.js
 */
import { LANGCN, LANGTW, LANGJA, LANGEN } from '@/utils/constant.js'

const lang = () => {
  const rowLang = (navigator.language || navigator.userLanguage || '').toLocaleLowerCase()
  if (rowLang.includes('zh-tw') || rowLang.includes('zh_hk') || rowLang.includes('zh-hk') || rowLang.includes('zh-mo') || rowLang.includes('zh_mo') || rowLang.includes('tw')) return LANGTW
  if (rowLang.includes('zh-cn') || rowLang.includes('zh-sg') || rowLang.includes('zh')) return LANGCN
  if (rowLang.includes('ja')) return LANGJA
  if (rowLang.includes('ko')) return LANGKO
  if (rowLang.includes('en')) return LANGEN
  return LANGCN
}

export default lang
